var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionSetNav',{attrs:{"display":_vm.displayNav,"name":_vm.currentCustomerName,"actions":_vm.actions}})}
var staticRenderFns = []

export { render, staticRenderFns }